function swymCallbackFn() {
    let fisrtTime = true;
    class WishListButton extends HTMLElement {
        constructor() {
            super();
            this.btn = this.querySelector("[data-product-id][data-variant-id]");
            this.idProduct = Number(this.btn.dataset.productId);
            this.idVariant = Number(this.btn.dataset.variantId);
            this.url = this.btn.dataset.url;
            this.image = this.btn.dataset.image;
            this.classActive = "wishlist-active";
            this.textElm = this.querySelector(".js-text-wishlist");
            this.checkWishlist();
            this.btn.addEventListener("click", this.toggleWishlist.bind(this));
        }

        checkWishlist() {
            window._swat.fetch((r) => {
                let check = r.some((w) => w.epi == this.idVariant && w.empi == this.idProduct);
                if (check) {
                    this.btn.classList.add(this.classActive);
                    this.btn.title = "In Wishlist";
                    if (this.textElm) this.textElm.textContent = "In Wishlist";
                } else {
                    this.btn.classList.remove(this.classActive);
                    this.btn.title = "Wishlist";
                    if (this.textElm) this.textElm.textContent = "Wishlist";
                }
                this.btn.classList.remove("disable-wait");
                this.classList.remove("loading");
            });
        }

        toggleWishlist(e) {
            e.preventDefault;
            this.classList.add("loading");
            this.idProduct = Number(this.btn.dataset.productId);
            this.idVariant = Number(this.btn.dataset.variantId);
            this.url = this.btn.dataset.url;
            this.image = this.btn.dataset.image;
            let button = this.btn;
            if (button.classList.contains(this.classActive)) {
                window._swat.removeFromWishList(
                    {
                        epi: this.idVariant, // variant id
                        du: window.location.origin + this.url,
                        empi: this.idProduct, // product id
                        iu: this.image,
                    },
                    (r) => {
                        button.classList.remove(this.classActive);
                        button.title = "Wishlist";
                        if (this.textElm) this.textElm.textContent = "Wishlist";
                        this.classList.remove("loading");                        
                    }
                );
            } else {
                window._swat.addToWishList(
                    {
                        epi: this.idVariant, // variant id
                        du: window.location.origin + this.url,
                        empi: this.idProduct, // product id
                        iu: this.image,
                    },
                    (r) => {                       
                        button.classList.add(this.classActive);
                        button.title = "In Wishlist";
                        if (this.textElm) this.textElm.textContent = "In Wishlist";
                        this.classList.remove("loading");
                    }
                );
            }
        }
    }

    customElements.define("component-wishlist", WishListButton);

    class ProductWishlistBtn extends WishListButton { 
        constructor() { 
            super();
        }
    }

    customElements.define("product-wishlist-btn", ProductWishlistBtn);

    class WishListDrawer extends HTMLElement {
        constructor() {
            super();
            this.drawer = document.getElementById('wishlist-drawer');
            this.cartDrawerOpen = document.querySelector('[data-js-wishlist-drawer="wishlistDrawerOpen"]');
            this.cartDrawerClose = document.querySelector('[data-js-wishlist-drawer="wishlistDrawerClose"]');
            this.main = document.querySelector('.wishlist-drawer__body');
            this.emptyText = this.drawer.dataset.emptyText ? this.drawer.dataset.emptyText : 'Your wishlist is currently empty!';

            this.drawer.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());
            this.querySelectorAll('[data-js-wishlist-drawer="wishlistDrawerClose"]').forEach((closeButton) => {
            this.activeElement = document.activeElement || this.cartDrawerOpen;
            closeButton.addEventListener('click', this.close.bind(this));
            });

            document.querySelectorAll('[data-js-wishlist-drawer="wishlistDrawerOpen"]').forEach((openButton) => {
            openButton.addEventListener('click', this.handleDrawerOpen.bind(this))
            });

            this.renderContents();
        }

        handleDrawerOpen() {
            this.open();
        }

        open() {
            this.activeElement = document.activeElement || this.cartDrawerOpen;
            this.drawer.classList.add('animate', 'active');

            this.drawer.addEventListener('transitionend', () => {
            this.drawer.focus();
            trapFocus(this.drawer, this.cartDrawerClose);
            }, { once: true });

            document.body.addEventListener('click', this.onBodyClick);
        }

        close() {
            this.drawer.classList.remove('active');

            document.body.removeEventListener('click', this.onBodyClick);

            removeTrapFocus(this.activeElement);
        }

        renderContents() {
            window._swat.fetch(async (r) => {
                if (r.length > 0) {
                    document.querySelector('.wishlist-drawer__inner').classList.remove('is-empty');
                    document.querySelector('.wishlist-drawer__footer').classList.remove('is-empty');
                    let arrUrl = r.map((i) => i.du);
                    this.main.classList.add("loading");
                    this.main.innerHTML = await buildListItem(arrUrl, "full-link", "wishlist-item");
                    await this.main.classList.remove("loading");
                } else {
                    this.main.innerHTML = `<p class="wishlist-empty">${this.emptyText}</p>`;
                    document.querySelector('.wishlist-drawer__inner').classList.add('is-empty');
                    document.querySelector('.wishlist-drawer__footer').classList.add('is-empty');
                }
            });
        }
    }

    customElements.define("wishlist-drawer", WishListDrawer);

    class WishListDrawerButton extends HTMLElement {
        constructor() {
            super();      
            window._swat.renderWishlistCount(
                this.querySelector("#wishlist-icon-bubble"),
                function (cnt, elem) {
                    if (!fisrtTime) { 
                        let drawer = document.querySelector('wishlist-drawer');
                        setTimeout(() => {
                            drawer.open();
                        }, 500);
                        setTimeout(() => {
                            drawer.close();
                        }, 3000);
                    }
                    if (parseInt(cnt) > 0) elem.closest("#wishlist-count").classList.remove("hidden");
                    else elem.closest("#wishlist-count").classList.add("hidden");
                    document.querySelectorAll("component-wishlist").forEach((elm) => elm.checkWishlist());
                    document.querySelector("wishlist-page") ? document.querySelector("wishlist-page").renderContents() : null;
                    document.querySelector('wishlist-drawer') ? document.querySelector('wishlist-drawer').renderContents() : null;
                    fisrtTime = false;
                },
                100
            );
        }
    }

    customElements.define("wishlist-drawer-button", WishListDrawerButton);

    class WishListPage extends HTMLElement {
        constructor() {
            super();
            this.main = this.querySelector("#wishlist-grid");
            this.renderContents();
        }

        renderContents() {
            window._swat.fetch(async (r) => {
                if (r.length > 0) {
                    let arrUrl = r.map((i) => i.du);
                    this.main.classList.add("loading");
                    this.main.innerHTML = await buildListItem(arrUrl, "full-link");
                    await this.main.classList.remove("loading");
                } else {
                    this.main.innerHTML = `<p class="wishlist-empty">No item</p>`;
                }
            });
        }
    }

    customElements.define("wishlist-page", WishListPage);
}

if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);